var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2967 52.6726L26.3909 49.2657H25.2947V52.6726H22.8754V43.0444H27.092C28.0499 43.0444 28.7905 43.2518 29.4027 43.6962C30.1434 44.2393 30.5384 45.1281 30.5384 46.0859C30.5384 47.2611 29.9755 48.4066 28.7115 48.9201L30.9235 52.6726H28.2967ZM26.7859 44.9306H25.2849V47.4783H26.7859C27.6549 47.4783 28.1881 46.9747 28.1881 46.1946C28.1881 45.3058 27.5956 44.9306 26.7859 44.9306Z",
    fill: "#25316A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0295 52.6726V43.0444H34.4489V52.6726H32.0295Z",
    fill: "#25316A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4924 49.3348H38.4976V52.6726H36.098V43.0444H40.443C42.576 43.0444 43.8203 44.3578 43.8203 46.1353C43.8104 47.7153 42.8426 49.3348 40.4924 49.3348ZM40.048 44.9306H38.4976V47.4783H40.048C40.8676 47.4783 41.4503 47.0438 41.4503 46.1847C41.4503 45.3453 40.9071 44.9306 40.048 44.9306Z",
    fill: "#25316A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.025 52.6726V43.0444H52.1153V44.9997H47.4345V46.8364H51.3746V48.7818H47.4345V50.6976H52.1449V52.6726H45.025Z",
    fill: "#25316A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6101 65.372L25.4034 59.052H25.3738V65.372H22.8853V54.6182H25.4923L29.5805 60.7012H29.6101V54.6182H32.1184V65.372H29.6101Z",
    fill: "#25316A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2507 65.5495C35.8807 65.5495 33.6687 64.3547 33.6687 61.6687V58.3902C33.6687 55.7535 35.8116 54.4204 38.1816 54.4204C40.2751 54.4204 42.5562 55.477 42.5562 57.9655V58.479H40.0183V58.2223C40.0183 57.1064 39.0703 56.6225 38.2408 56.6225C37.2928 56.6225 36.3745 57.1163 36.3745 58.3408V61.5995C36.3745 62.7055 37.1743 63.3375 38.2705 63.3375C39.1 63.3375 40.0183 62.8734 40.0183 61.7378V61.481H42.5562V62.0044C42.5562 64.4929 40.3343 65.5495 38.2507 65.5495Z",
    fill: "#25316A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3726 65.5495C46.0026 65.5495 43.7906 64.3547 43.7906 61.6687V58.3902C43.7906 55.7535 45.9335 54.4204 48.3035 54.4204C50.397 54.4204 52.6781 55.477 52.6781 57.9655V58.479H50.1403V58.2223C50.1403 57.1064 49.1923 56.6225 48.3628 56.6225C47.4148 56.6225 46.4964 57.1163 46.4964 58.3408V61.5995C46.4964 62.7055 47.2963 63.3375 48.3924 63.3375C49.2219 63.3375 50.1403 62.8734 50.1403 61.7378V61.481H52.6683V62.0044C52.6683 64.4929 50.4563 65.5495 48.3726 65.5495Z",
    fill: "#25316A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9657 22.0897V13.9724L37.4311 9.62744L29.8965 13.9724V22.0897L22.8754 26.1384V34.8383L30.41 39.1833L37.4311 35.1346L44.4522 39.1833L51.9869 34.8383V26.1384L44.9657 22.0897ZM37.4311 25.8323L31.437 22.3761L37.4311 18.9198L43.4252 22.3761L37.4311 25.8323ZM30.9334 23.2747L36.9275 26.7309V33.6434L30.9334 30.1872V23.2747ZM37.9545 26.7309L43.9486 23.2747V30.1872L37.9545 33.6434V26.7309ZM30.9334 14.5649L37.441 10.8124L43.9486 14.5649V21.4873L37.441 17.7348L30.9334 21.4873V14.5649ZM23.9122 34.2458V26.7309L29.9064 23.2747V30.7797L36.4239 34.5421L30.4199 38.0082L23.9122 34.2458ZM50.9599 34.2458L44.4522 37.9983L38.4482 34.5322L44.9657 30.7698V23.2648L50.9599 26.7211V34.2458Z",
    fill: "url(#paint0_linear_16_493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_493",
    x1: 26.6921,
    y1: 38.654,
    x2: 48.1702,
    y2: 17.1759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25316A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.060518,
    stopColor: "#293269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#343468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#453764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2446,
    stopColor: "#5B3C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3064,
    stopColor: "#764459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3684,
    stopColor: "#964D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#BF5A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4872,
    stopColor: "#F36C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipe);
export default __webpack_public_path__ + "static/media/ripe.61b28b16a12c2b212fd8082a53c934f0.svg";
export { ForwardRef as ReactComponent };